import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { MatTable } from '@angular/material/table';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { GlobalFunctionsService } from '@_services/global-functions.service';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-interst-rates',
  templateUrl: './interst-rates.component.html',
  styleUrls: ['./interst-rates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InterstRatesComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  isspiner: boolean = false;
  confirmDialogRef: any;
  secondData: boolean = true;
  firstData: boolean = false;
  getDataForTable: any = [];
  highlightedRows: any;
  theme_type: string | null = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  showDate: any;
  sendDate: any;
  whichType: any;
  FormAction: any;
  CurrentRowselcted: any = {};
  sendInterstGUID: any;
  @Output() callLoading = new EventEmitter<string>();
  displayedColumns: string[] = ['Action', 'name', 'rate'];
  maintainFlag: boolean = false;
  class: boolean;
  ShowDuplicateBotton: boolean;
  @ViewChild(MatTable) table: MatTable<any>;
  isExpandedRow = (_index: number, row: any): boolean => !!row?.expanded;
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private globalFunService: GlobalFunctionsService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingInterstRatesComponent');
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingInterstRatesComponent' &&
          result['click'] &&
          result['data']['interest-rate']
        ) {
          this.finalSave('save');
        }
        this.cd.markForCheck();
      },
    });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          this.class = data;
          this.cd.markForCheck();
        },
      });
    this.SettingForm.get('EFFECTIVEDATE').disable();
    this.SettingForm.get('INTERESTRATE').disable();
    // this.SettingForm.
    this.SettingForm.controls['EFFECTIVEDATE'].setValue(new Date());
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(
      this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
    );
    this.SettingForm.controls['INTERESTRATE'].setValue(0);
    this.loadData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This funtion is used to load the data value
   */
  loadData() {
    let Payload = {
      // "ACTION": "default",
      // "DATA": {},
      Action: 'GetData',
      Filters: {},
    };
    this._mainAPiServiceService
      .getSetData(Payload, 'interest-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.getDataForTable = response.DATA.INTERESTRATES;
            response.DATA.RECORDS.forEach((element: any) => {
              element['expanded'] = false;
              this.getDataForTable = response.DATA.RECORDS;
            });
            this.maintainFlag = false;
            this.highlightedRows = this.getDataForTable[0].INTERESTGUID;
            this.CurrentRowselcted = this.getDataForTable[0];
            this.itemChange('edit');
            this.behaviorService.loadingSystemSetting('interst-rates');
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
  get f() {
    return this.SettingForm.controls;
  }

  /**
   * This function is used to click on the row
   */
  async rowclick(val: any) {
    this.CurrentRowselcted = val;
    this.highlightedRows = val.INTERESTGUID;
    this.cd.markForCheck();
  }
  CurrencyClassChange(val: any) {}

  /**
   * This function is used to change the item data value
   */
  itemChange(val: any) {
    this.whichType = val;
    if (val == 'add') {
      this.secondData = false;
      this.SettingForm.get('EFFECTIVEDATE').enable();
      this.SettingForm.get('INTERESTRATE').enable();
      this.SettingForm.controls['EFFECTIVEDATE'].setValue('');
      this.SettingForm.controls['INTERESTRATE'].setValue('');
      this.firstData = true;
    } else if (val == 'edit') {
      // if(!isNaN(this.CurrentRowselcted.EFFECTIVEDATE)){
      let date = this.CurrentRowselcted.EFFECTIVEDATE.split('/');
      let sendDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
      this.SettingForm.controls['EFFECTIVEDATE'].setValue(sendDate);
      this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(this.CurrentRowselcted.EFFECTIVEDATE);
      // }
      this.SettingForm.controls['INTERESTRATE'].setValue(this.CurrentRowselcted.INTERESTRATE);
      this.secondData = false;
      this.SettingForm.get('EFFECTIVEDATE').enable();
      this.SettingForm.get('INTERESTRATE').enable();
      this.firstData = true;
    } else if (val == 'DUPLICATE') {
      this.finalSave(val);
    }
    this.cd.markForCheck();
  }

  /**
   * This function is used to exchange the Date
   */
  exchangeDate1(val1: any, val2: any) {}

  /**
   * This function is used to exchange the Date
   */
  exchangeDate(type: string, event: MatDatepickerInputEvent<Date>) {
    const formattedDate = this.datepipe.transform(event.value, 'dd/MM/yyyy');
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(formattedDate);
    this.cd.markForCheck();
  }

  /**
   * This function is used to dont save
   */
  dontsave() {
    this.firstData = false;
    this.secondData = true;
    this.SettingForm.get('EFFECTIVEDATE').disable();
    this.SettingForm.get('INTERESTRATE').disable();
    this.cd.markForCheck();
  }
  finalSave(val: any) {
    this.firstData = false;
    this.secondData = true;
    //this.SettingForm.get('EFFECTIVEDATE').disable();
    // this.SettingForm.get('INTERESTRATE').disable();
    if (this.whichType == 'add') {
      this.FormAction = 'insert';
      this.sendInterstGUID = '';
    } else if (this.whichType == 'edit') {
      this.FormAction = 'update';
      this.sendInterstGUID = this.CurrentRowselcted.INTERESTGUID;
    } else if (this.whichType == 'delete') {
      this.FormAction = 'delete';
      this.sendInterstGUID = this.CurrentRowselcted.INTERESTGUID;
    } else if (this.whichType == 'DUPLICATE') {
      this.FormAction = 'insert';
    }
    let sendData = {
      SCALE_: this.f.SCALE_.value,
      INTERESTGUID: this.sendInterstGUID,
      EFFECTIVEDATE: this.f.sendEFFECTIVEDATE.value,
      INTERESTRATE: this.f.INTERESTRATE.value,
    };
    if (this.whichType == 'DUPLICATE') {
      // delete sendData.INTERESTGUID
    }

    let details = {
      Action: this.FormAction,
      VALIDATEONLY: true,
      Data: sendData,
    };
    this._mainAPiServiceService
      .getSetData(details, 'interest-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.checkValidation(response.DATA.VALIDATIONS, details);
            this.maintainFlag = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.checkValidation(response.DATA.VALIDATIONS, details);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.checkValidation(response.DATA.VALIDATIONS, details);
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  async checkValidation(bodyData: any, PostActivityData: any, ApiName?: any) {
    this.isspiner = false;
    await this.globalFunService
      .checkValidation(bodyData, PostActivityData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.errorWarningData = data.errorWarningData;
            if (data.callback) {
              this.saveSpendMoneyData(PostActivityData);
            }
          }
          this.cd.markForCheck();
        },
        error: (err: any) => {
          console.error(err);
          this.cd.markForCheck();
        },
      });
  }
  saveSpendMoneyData(data: any) {
    data.VALIDATEONLY = false;
    this._mainAPiServiceService
      .getSetData(data, 'interest-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            if (this.whichType !== 'edit') {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Saved successfully');
            } else {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Updated successfully');
            }
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
            this.isspiner = false;
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
  deleteItem() {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          let postData = {
            Action: 'delete',
            DATA: { INTERESTGUID: this.CurrentRowselcted.INTERESTGUID },
          };
          this._mainAPiServiceService
            .getSetData(postData, 'interest-rate')
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe({
              next: (res: any) => {
                if (res.STATUS == 'success' && res.CODE == 200) {
                  this.callLoading.next(null);
                  this.loadData();
                  this.toastr.success('Deleted successfully');
                  this.maintainFlag = false;
                }
                this.cd.markForCheck();
              },
              error: (err: any) => {
                console.error(err);
                this.cd.markForCheck();
              },
            });
        }
        this.confirmDialogRef = null;
        this.cd.markForCheck();
      },
    });
  }

  async toggleRow(element: any) {
    this.SettingForm.controls['sendEFFECTIVEDATE'].setValue(element.EFFECTIVEDATE);
    this.ShowDuplicateBotton = false;
    this.maintainFlag = false;
    this.CurrentRowselcted = element;
    this.itemChange('edit');
    if (element.expanded == true) {
      element.expanded = !element.expanded;
    } else {
      // Uncommnet to open only single row at once
      this.getDataForTable.forEach((row: any) => {
        row.expanded = false;
      });
      element.expanded = !element.expanded;
    }
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  async getValue() {
    await this.itemChange('add');
    this.maintainFlag = true;
    this.getDataForTable.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  AddDuplicateData() {
    this.maintainFlag = false;
    this.itemChange('edit');
    this.ShowDuplicateBotton = false;
    this.getDataForTable.forEach((row: any) => {
      row.expanded = false;
    });
    setTimeout(() => {
      this.getDataForTable.forEach((row: any) => {
        if (row.INTERESTGUID != this.CurrentRowselcted.INTERESTGUID) {
          row.expanded = false;
        } else {
          this.ShowDuplicateBotton = true;
          this.CurrentRowselcted.expanded = true;
        }
      });
      this.table?.renderRows();
      this.cd.markForCheck();
    }, 300);
    this.cd.markForCheck();
  }

  CollapstExpandedrow() {
    this.CurrentRowselcted.expanded = false;
    this.table?.renderRows();
    this.cd.markForCheck();
  }
}
